// Bolinha de estado. Dois usos, e é o `label` que os separa:
//   sem label — DECORAÇÃO ao lado de um rótulo escrito (chips de filtro): o
//               texto vizinho já diz o estado, então a bolinha é aria-hidden.
//   com label — a bolinha É o sinal, sozinha (linha da fila): cor sozinha não
//               sinaliza nada para quem não a distingue, então o estado por
//               extenso vai no nome acessível e no title.

export type StatusBulletTone = 'error' | 'warning' | 'information' | 'neutral'

interface StatusBulletProps {
  tone: StatusBulletTone
  /** Estado por extenso, obrigatório quando a bolinha aparece sem texto ao lado. */
  label?: string
}

const HALO_CLASSES: Record<StatusBulletTone, string> = {
  error: 'bg-stroke-error-weak',
  warning: 'bg-stroke-warning-weak',
  information: 'bg-stroke-information-weak',
  neutral: 'bg-stroke-weak',
}

const DOT_CLASSES: Record<StatusBulletTone, string> = {
  error: 'bg-fill-error-strong',
  warning: 'bg-fill-yellow',
  information: 'bg-fill-information-strong',
  neutral: 'bg-icon-neutral',
}

export function StatusBullet({ tone, label }: StatusBulletProps) {
  const decorative = label === undefined
  return (
    <span
      aria-hidden={decorative ? true : undefined}
      role={decorative ? undefined : 'img'}
      aria-label={label}
      title={label}
      data-status-bullet
      data-tone={tone}
      className={`inline-flex size-3 shrink-0 items-center justify-center rounded-full ${HALO_CLASSES[tone]}`}
    >
      <span className={`size-2 rounded-full ${DOT_CLASSES[tone]}`} />
    </span>
  )
}
